export default __webpack_public_path__ + "static/media/ic-crops-lily.3f33b212.svg";